// stock status of an item (badge + filter)
export const STOCK_STATUS = {
  inStock: { label: "In Stock", color: "success" },
  low: { label: "Low Stock", color: "warning" },
  out: { label: "Out of Stock", color: "danger" },
};

/**
 * Splits a quantity in base units (pcs, or tests for reagents) into what the
 * shelf shows. Items in packs (e.g. box of 100) count whole packs: the sealed
 * ones are complete, a partly used pack is open with what is left in it.
 * Items without packs are counted by piece: what was used is open.
 *
 * Returns { total, open, remaining, openLeft } in display units.
 */
export const shelfOf = ({ available = 0, consumed = 0 }, packQty = 1) => {
  if (packQty > 1) {
    const complete = Math.floor(available / packQty);
    const openLeft = available % packQty;
    const open = openLeft ? 1 : 0;
    return { total: complete + open, open, remaining: complete, openLeft };
  }
  return {
    total: available + consumed,
    open: consumed,
    remaining: available,
    openLeft: 0,
  };
};

// "2 boxes", "1 box", "40 pcs"
export const unitText = (qty, unit) =>
  `${qty} ${unit}${
    qty === 1 || /s$/i.test(unit) ? "" : /(x|ch|sh)$/i.test(unit) ? "es" : "s"
  }`;
